
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/why-partner",
      function () {
        return require("private-next-pages/sa/why-partner.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/why-partner"])
      });
    }
  